import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewProductSubCategory';


const ViewProductSubCategory = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Product Sub Category MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewProductSubCategory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewProductSubCategory);
